module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/24b564be24fc41c34db3562ac3859132.png";